import { Box, Typography } from '@cambridgeassessment/cambridge-ui';
import React from 'react';
import { useStyles } from './styles';

interface BannerProps {
  children: React.ReactNode;
}

const Banner: React.FC<BannerProps> = ({ children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.banner}>
      <Typography className={classes.bannerText}>{children}</Typography>
    </Box>
  );
};

export default Banner;
